module.exports = __webpack_public_path__ + "static/3-c87742c1aab542fdf2195df755ba1470.jpg";